// extracted by mini-css-extract-plugin
module.exports = {"jackpotWrapperInner":"JackpotPageRestyled_jackpotWrapperInner___tsE7","jackpot":"JackpotPageRestyled_jackpot__33THJ"};